import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {userChartGetByDashboardID} from "../requests/UserChart";
import {Typography} from "antd";
import {userGetByEmail} from "../requests/User";
import {generateURL} from "../requests/LookerURLRoute";
import {Auth} from "aws-amplify";

const {Title} = Typography;


class EmbedDashboard extends Component {

    url = new URL(window.location.href);

    constructor(props) {
        super(props);
        this.state = {
            currentUserName: null,
            dashboardID: this.props.match.params.id,
            search: this.url.search,
            item: null
        };
    }


    componentDidMount() {
        Auth.currentSession().then((res) => {
            this.setState({currentUserName: res.getAccessToken().payload.username});
        }).then(() => {
            userChartGetByDashboardID({
                    userId: this.state.currentUserName,
                    dashboardID: this.props.match.params.id
                },
                (response) => {
                    userGetByEmail(this.props.auth, (r2) => {
                        let url = generateURL(response.data, r2.data);
                        this.setState({item: response.data, url: url});
                    });
                });
        });

    }


    render() {
        const {item, url} = this.state;
        const a = item !== null ? (<Redirect to={{
            pathname: '/dashboard/' + item._id,
            state: {
                url: url,
                item: item
            }
        }}
        />) : (<div style={{background: '#fff', padding: 20, minHeight: '100%', textAlign: "center"}}>
                <Title level={4}>You don't have permission to view the embedded dashboard. Please contact
                    support.</Title>
            </div>
        );

        return (
            <React.Fragment>
                {a}
            </React.Fragment>

        );
    }
}

export default withRouter(EmbedDashboard);
